import React, { useState, useEffect } from "react";
import { Layout, Menu, Card, Typography } from "antd";
import { motion, AnimatePresence } from "framer-motion";
import pose from "../../Assets/Neti/pose.jpg";
import axios from "axios";
import { API_BASE_URL } from "../../Config";
import { useSlugMenu } from "../../hooks/useSlugMenu";
import AdvertisementCard from "../AdvertisementCard";

const { Sider, Content } = Layout;
const { Title, Paragraph } = Typography;

const Shatkarmas = () => {  const [allYogaPages, setAllYogaPages] = useState([]);
  const { selectedKey, selectedPage, handleMenuClick } = useSlugMenu(allYogaPages, "/shatkarmas");
  const [openKeys, setOpenKeys] = useState([]);

  // Opened from a link like /shatkarmas/<page>: expand that page's group
  useEffect(() => {
    const type = selectedPage?.shatkarmasType;
    if (type && type !== "others") {
      setOpenKeys((keys) => (keys.includes(type) ? keys : [...keys, type]));
    }
  }, [selectedPage]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAllYoga = async () => {
      try {
        const res = await axios.get(`${API_BASE_URL}/allpages?page=shatkarmas`);
        const json = await res.data;
        setAllYogaPages(json?.data || []);
      } catch (error) {
        console.error("API Fetch Error", error);
      } finally {
        setLoading(false);
      }
    };

    fetchAllYoga();
  }, []);

  const getDynamicPageContent = (key) => {
    if (key === "home") {
      const home = allYogaPages.find((p) => p.yogaType === "Yoga Main Page");
      if (home) return home.content;

      return `
         <div style={{ maxWidth: 800, margin: "0 auto", padding: "20px 30px", lineHeight: 1.8 }}>

      <h1 style={{ textAlign: "center" }}>
        The Shatkarmas of Yoga or the "six cleansing practices"
      </h1>

      <h2 style={{ color: "#0c5c78" }}>Purpose of Shatkarmas:</h2>
      <Paragraph style={{ lineHeight: 1.7 }}>
        The main purpose of these is to remove waste products, toxins (doshas) and excess mucus
        from the body and achieve body-mind balance (doshas bhavana). This prepares the body for
        yoga and meditation.
      </Paragraph>

      <h2 style={{ color: "#0c5c78" }}>The six practices of Shatkarmas:</h2>
      <ol style={{ lineHeight: 1.8 }}>

        
        <li><b>Neti - Nasal cleansing</b></li>
        <p>The practice of cleansing the respiratory tract through the nose.</p>
        <p><b>A. Jala Neti: </b>Salt water is poured into a special pot (Neti Pot) and is done in such a way that it enters one nostril and comes out the other.</p>
        <p><b>B. Sutra Neti: </b>A thin rubber cord or cotton thread is passed through the nose to cleanse it.</p>

        
        <li><b>Dhauti - Digestive tract cleansing</b></li>
        <p>Practices to cleanse the mouth, esophagus and stomach.</p>
        <p><b>A. Kunjal Kriya/Vaman Dhauti: </b>Purifying the stomach by drinking water and intentionally vomiting.</p>
        <p><b>B. Vatsara Dhauti: </b>Inhaling air through the mouth and expelling it through the stool (a more advanced practice).</p>
        <p><b>C. Agnisara Dhauti: </b>Rapidly activating the stomach and strengthening the digestive fire (Agni).</p>

        
        <li><b>Nauli - Abdominal muscle cleansing</b></li>
        <p>A practice of individually activating the abdominal muscles and massaging the digestive organs.</p>
        <p><b>A. Madhyama Nauli: </b>Bringing the abdominal muscles to the middle.</p>
        <p><b>B. Vama Nauli: </b>Only activating the left abdominal muscles.</p>
        <p><b>C. Dakshina Nauli: </b>Only the right abdominal muscles are involved.</p>
        <p>This is a very advanced practice; it should only be practiced under the supervision of a teacher.</p>

        
        <li><b>Basti - Colon cleansing</b></li>
        <p>A practice of cleansing the colon. It is divided into two types: Yoga Sthula Basti (water basti) and Yoga Suksma Basti (air basti). Today, water basti is less commonly practiced by yogis than oil pouring.</p>

        
        <li><b>Trataka - Eye purification and concentration</b></li>
        <p>Fixing a specific point (flame, dot, object) with the eyes unblinking, then closing the eyes and imagining that image in the mind.</p>
        <p><b>A. Bahya Trataka: </b>Looking at an external object.</p>
        <p><b>B. Antar Trataka: </b>Seeing an image in the mind's eye.</p>

        
        <li><b>Kapalbhati - Skull Light Breathing</b></li>
        <p>A breathing exercise involving a forceful exhalation and a passive inhalation.</p>
        <p><b>A. Vatakrama Kapalbhati: </b>Forceful exhalation by suddenly contracting the chest muscles.</p>
        <p><b>B. Vyutkrama Kapalbhati: </b>Inhaling salt water through the nose and spitting it out through the mouth.</p>
        <p><b>C. Sheetkrama Kapalbhati: </b>Inhaling water through the mouth and spitting it out through the nose.</p>

      </ol>

      <h2 style={{ color: "#0c5c78" }}>General benefits of Shatkarmas:</h2>
      <ol style={{ lineHeight: 1.8 }}>
        <li>Removal of toxins (doshas) from the entire body.</li>
        <li>Increased immunity.</li>
        <li>Improved digestion.</li>
        <li>Increased mental clarity and concentration.</li>
        <li>Increases the benefits of yoga asanas and pranayama.</li>
      </ol>

      <h2 style={{ color: "#c0392b" }}>Important Warning:</h2>
      <ol style={{ lineHeight: 1.8 }}>
        <li>
          All these practices are powerful. Especially the more advanced practices like Dhauti,
          Nauli, Basti etc. should be learned and practiced only under the direct supervision and
          guidance of a qualified yoga guru. Doing them incorrectly can lead to injury or health problems.
        </li>
        <li>Consult a yoga expert to choose the Shatkarma practice that suits your physical condition and needs.</li>
        <li>In yoga, it is considered best to do Bandhas (energy locks) only after doing Shatkarmas (purification).</li>
        <li>
          <b>Logic: </b>Before using a pipe (body), just like cleaning it, one should purify the
          body before letting energy flow through it.
        </li>
      </ol>

      <h2 style={{ color: "#0c5c78" }}>Conclusion:</h2>
      <Paragraph style={{ lineHeight: 1.7 }}>
        Uddiyana bandha is not a shatkarma; it is a bandha. This is an advanced energy technique
        that is performed after cleansing techniques.
      </Paragraph>

    </div>
      `;
    }

    const page = allYogaPages.find((p) => p._id === key);
    return page?.content || "<p>No content found.</p>";
  };

  const grouped = {};

  allYogaPages.forEach((item) => {
    const type = item.shatkarmasType;

    if (!grouped[type]) grouped[type] = [];
    grouped[type].push(item);
  });

  const menuItems = [
    ...Object.keys(grouped)
      .map((type) => {
        const items = grouped[type];

        if (type === "others") {
          return items.map((item) => ({
            key: item._id,
            label: item.yogaType,
          }));
        }

        if (items.length > 1) {
          return {
            key: type,
            label: type.charAt(0).toUpperCase() + type.slice(1),
            children: items.map((item) => ({
              key: item._id,
              label: item.yogaType,
            })),
          };
        }

        return {
          key: type,
          label: type.charAt(0).toUpperCase() + type.slice(1),
          children: [
            {
              key: items[0]._id,
              label: items[0].yogaType,
            },
          ],
        };
      })
      .flat(),

    {
      key: "home",
      label: "Back to Mainpage",
    },
  ];

  const selectedContent = (
    <div
      className="page-content"
      dangerouslySetInnerHTML={{ __html: getDynamicPageContent(selectedKey) }}
    />
  );

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
      style={{
        display: "flex",
        justifyContent: "center",
        padding: "30px 10px",
        minHeight: "100vh",
        background: "#f0f2f5",
      }}
    >
      <Layout
        className="responsive"
        style={{
          width: "90%",
          maxWidth: "1200px",
          background: "#fff",
          borderRadius: "16px",
          boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
          display: "flex",
          overflow: "hidden",
        }}
      >
        <Sider
          className="sub_slider"
          width={250}
          style={{
            height: "900px",
            backgroundImage: `url(${pose})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            position: "relative",
          }}
        >
          <div
            style={{
              position: "absolute",
              inset: 0,
              background: "rgba(0,0,0,0.6)",
            }}
          />

          <div
            style={{
              position: "relative",
              zIndex: 2,
              padding: "16px",
              fontWeight: "bold",
              textAlign: "center",
              color: "#fff",
            }}
          >
            Explore Shatkarmas
          </div>

          <Menu
            theme="white"
            mode="inline"
            style={{
              background: "transparent",
              color: "#ffffffA2",
              fontSize: "1.1rem",
              position: "relative",
              zIndex: 2,
              fontWeight: 500,
              textAlign: "center",
            }}
            itemStyle={{ color: "#fff" }}
            onClick={handleMenuClick}
            openKeys={openKeys}
            onOpenChange={setOpenKeys}
            selectedKeys={[selectedKey]}
            items={menuItems}
          />
        </Sider>

        <Content className="content_responsive" style={{ padding: "30px" }}>
          {loading ? (
            <h2>Loading...</h2>
          ) : (
            <AnimatePresence mode="wait">
              <motion.div
                key={selectedKey}
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -20 }}
                transition={{ duration: 0.4 }}
              >
                <Card
                  className="inner_card"
                  style={{ borderRadius: "12px", padding: "24px" }}
                >
                  {selectedContent}
                </Card>
              </motion.div>
            </AnimatePresence>
          )}
        </Content>
      </Layout>
      <AdvertisementCard />
    </motion.div>
  );
};

export default Shatkarmas;
